import script from "./download.vue?vue&type=script&setup=true&lang=js"
export * from "./download.vue?vue&type=script&setup=true&lang=js"

import "./download.vue?vue&type=style&index=0&id=6502bd62&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6502bd62"]])

export default __exports__